import React from "react"
import { RouterProvider, createBrowserRouter } from "react-router-dom"
import Root from "./Root"
import GlobalErrorBoundary from "./providers/GlobalErrorBoundary"
import "./styles/hiddenHoverButton.css"
import WebSocketProvider from "./websocket/wsProvider"
class App extends React.Component {
	render() {
		const router = createBrowserRouter([
			{
				path: "*",
				element: (
					
						<WebSocketProvider>
							{/* O Provider envolve o componente Root */}
							<GlobalErrorBoundary>
								<Root />
							</GlobalErrorBoundary>
						</WebSocketProvider>
					
				),
			},
		])

		return <RouterProvider router={router} />
	}
}

export default App